import "core-js/stable";
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./app/App";
import "semantic-ui-css/semantic.min.css";
import "react-virtualized/styles.css";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
